// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"ace9b8e0","788":"a0d3156e"}[chunkId] + ".chunk.js";
};